<template lang="pug">
 .stages-list
        h2.title {{ getTitle }}
        .actors
            .person(v-for="actor in ActorList" :key="actor.id")
                .person_details
                    .img-container
                        aiq-image(v-if="getType(actor) === 'agent'" :src="avatar(actor)" :key="avatar(actor)")
                        fa-icon(v-else :icon="['fas', 'people-group']" class="fa-icon")
                    .person_name {{ actorDetails(actor) }}
                    .person_date {{ actorDate(actor) }}
</template>
<script>
import get from 'lodash/get';
import dayjs from '@/localPlugins/dayjs';
import { defaultProfile } from '@/libs';

export default {
  name: 'ActorList',
  data() {
    return {
      baseTranslationPath: 'settings_tab.admin_tab.smart_control.control_list_manage',
    };
  },
  props: {
    ActorList: {
      type: Array,
      default: () => [],
    },
    showTime: {
      type: Boolean,
      default: true,
    },
    listType: {
      type: String,
      required: true,
    },
  },
  methods: {
    avatar(item) {
      return get(item, 'picture.payload.url', defaultProfile.picture);
    },
    getType(item) {
      const agentTypes = ['skippers', 'approvers', 'rejecters'];
      if (agentTypes.includes(this.listType)) {
        return 'agent';
      }
      const type = get(item, 'assignee_type');
      return type;
    },
    actorDetails(item) {
      const name = get(item, 'name');
      return `${name}`;
    },

    actorDate(item) {
      const date = get(item, 'done_at');
      if (!date) return '';
      if (!this.showTime) return '';
      return `${this.getTime(date)}`;
    },
    getTime(date) {
      if (date) {
        return `(${dayjs(date).format('MM/DD/YYYY hh:mm A')})`;
      }
      return '';
    },
  },
  computed: {
    getTitle() {
      if (this.listType === 'approvers') {
        return this.$t(`${this.baseTranslationPath}.approved_by`);
      } else if (this.listType === 'rejecters') {
        return this.$t(`${this.baseTranslationPath}.rejected_by`);
      } else if (this.listType === 'assignees') {
        return this.$t(`${this.baseTranslationPath}.assignees`);
      } else if (this.listType === 'skippers') {
        return this.$t(`${this.baseTranslationPath}.skipped_by`);
      }
      else {
        return '';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
    font-size: 18px;
    font-weight: 500;
    line-height: 24px
}
.person_details {
    display: flex;
    align-items: center;
    gap: 10px;
}
.person_name {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
}
img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
}
.fa-icon {
    width: 30px;
    height: 30px;
}
.person {
    margin-bottom: 10px;
    padding-top: 10px;
    padding-left:25px;
}
.person_date {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: #6a7682
}
</style>